import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/**
 * TOKEN_KEY holds a short-lived JWT (signed by the backend, no PII).
 * We prefer an httpOnly cookie for auth (set by the server on login).
 * localStorage is used ONLY as a fallback when third-party cookies are
 * blocked by the browser (Safari/iOS). Trade-off: XSS could exfiltrate
 * this token, so we do not render any user-supplied HTML anywhere in
 * the app and rely on React's automatic escaping.
 */
const TOKEN_KEY = "webup_token";

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach Bearer token (localStorage fallback) on every request
api.interceptors.request.use((config) => {
  try {
    const token = window.localStorage?.getItem(TOKEN_KEY);
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (err) {
    // storage may be unavailable (private mode, SSR, quota) — log in dev only
    if (process.env.NODE_ENV !== "production") {
      console.debug("Token read from localStorage failed:", err?.message);
    }
  }
  return config;
});

export const setAuthToken = (token) => {
  try {
    if (token) window.localStorage.setItem(TOKEN_KEY, token);
    else window.localStorage.removeItem(TOKEN_KEY);
  } catch (err) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("localStorage unavailable, session limited to cookie", err);
    }
  }
};

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_a21e49e6-ca94-4555-9c00-eecf07497664/artifacts/9tjh00un_ChatGPT%20Image%2016%20juin%202026%2C%2014_49_11.png";
